export const PRODUCTADD = 'product/addProduct'
export const INCREASEQTY = 'product/increase'
export const DECREASEQTY = 'product/decrease'
export const PRODUCTDELETED = 'product/productDeleted'